var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container font-body text-gray-800",attrs:{"id":"app"}},[_c('calculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }